import React, { useEffect, useState } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { styled } from '@mui/material/styles';

const LoadingOverlay = styled(motion.div, {
  shouldForwardProp: (prop) => prop !== 'overlayZIndex'
})(({ overlayZIndex }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(255, 255, 255, 0.8)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: overlayZIndex ?? 9999
}));

const LoadingSpinner = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.primary.main
}));

const LoadingText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(3),
  color: theme.palette.primary.main,
  fontWeight: 500
}));

const LoadingIndicator = ({ isLoading, message, zIndex }) => {
  // 내부 state로 prop 변경을 추적
  const [internalLoading, setInternalLoading] = useState(isLoading);

  useEffect(() => {
    setInternalLoading(isLoading);
  }, [isLoading]);
  
  useEffect(() => {
    if (internalLoading) {
      const elements = document.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      elements.forEach(el => {
        if (el instanceof HTMLElement) {
          el.blur();
          el.tabIndex = -1;
        }
      });

      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }

      document.body.style.overflow = 'hidden';

      return () => {
        elements.forEach(el => {
          if (el instanceof HTMLElement) {
            el.tabIndex = 0;
          }
        });
        document.body.style.overflow = '';
      };
    } else {
      // internalLoading이 false일 때도 스크롤 복원 보장
      document.body.style.overflow = '';
    }
  }, [internalLoading]);

  return (
    <AnimatePresence>
      {internalLoading && (
        <LoadingOverlay
          overlayZIndex={zIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onKeyDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <LoadingSpinner size={60} thickness={4} />
          <LoadingText variant="h6">
            {message}
          </LoadingText>
        </LoadingOverlay>
      )}
    </AnimatePresence>
  );
};

export default LoadingIndicator;